import React, {
  useEffect,
  useLayoutEffect,
  useCallback,
  useMemo,
  useState,
  useRef,
} from 'react';
import useMeasure from 'react-use-measure';
import isEqual from 'lodash.isequal';
import { useSpring, animated, to } from 'react-spring';
import { useGesture } from 'react-use-gesture';
import { clamp } from '../../helpers';

const isClient = typeof window !== 'undefined';

const immediateConfig = {
  config: { duration: 0 },
};
const defaultConfig = {
  config: {
    tension: 340,
    friction: 38,
  },
};

const GestureHandler = ({
  pdfEl,
  handleZoom,
  onDoubleClick,
  swipeRight,
  swipeLeft,
  shouldCenter,
  computedWidth,
  topMargin,
  children,
}) => {
  // the container ('viewport' minus the AppBar)
  const [ref, { width: elWidth, height: elHeight }] = useMeasure();

  const [lastPos, setLastPos] = useState({
    x: 0,
    y: 0,
  });
  const [pointer, setPointer] = useState({
    pointerX: 0,
    pointerY: 0,
  });
  const [pinchOrigin, setPinchOrigin] = useState({
    x: 0,
    y: 0,
  });
  const [disableBounds, setDisableBounds] = useState(false);
  const [lastAction, setLastAction] = useState(null);

  const [lastWidth, setLastWidth] = useState(computedWidth);
  const [{ x, y }, set] = useSpring(() => ({
    x: 0,
    y: 0,
    ...defaultConfig,
  }));
  const [{ zoom }, setZoom] = useSpring(() => ({
    zoom: 1,
  }));
  // useEffect(() => {
  //   if(ref.current){

  //     isClient && ref && ref.addEventListener('dblclick', onDoubleClick);
  //   }
  //   return () => {
  //     isClient && ref && ref.removeEventListener('dblclick', onDoubleClick);
  //   };
  // }, [ref]);

  useEffect(() => {
    center();
  }, [shouldCenter]);

  const pdfDimensions = useMemo(() => {
    if (pdfEl) {
      console.log('pdfEl memo');
      return pdfEl.getBoundingClientRect();
    }
  }, [
    pdfEl?.getBoundingClientRect().width,
    pdfEl?.getBoundingClientRect().height,
  ]);

  // recenter the drag position
  // useing the pointer val
  // (triggered when the user double taps or zooms)
  // note this brings the pointer pos to the center of the
  // viewport, within the bounds

  const relocateToPointer = () => {
    // this reacts to changes in the pdf document container width/height
    // and sets the new xy pos based on the pointer pos
    // it clamps it to the boundary and centers the view on the pointer pos
    // (i.e this is the double click (and pinch zoom) effect)

    const { width: pdfWidth, height: pdfHeight } = pdfDimensions;

    console.log('cwlw', { computedWidth, lastWidth, pointer });
    console.log(
      'pointer adjust:',
      lastPos,
      lastPos.x + -pointer.pointerX,
      lastPos.y + -pointer.pointerY
      // -lastPos.pointer.pointerX - -elWidth / 2,
      // -lastPos.pointer.pointerY - -elHeight / 2
    );

    // console.log('currentZoom ratio?', currentZoom);
    // console.log('zoom spring', zoom.get(), lastPos.zoom);
    const lw = lastWidth || computedWidth;
    // this seems to succesfully move to the pointer pos after scaling
    // but we probably want to then center that
    const ratio = lastPos.zoom ? lastPos.zoom : computedWidth / lw;
    console.log('cwlw ratio', ratio);
    let pointerX = pointer.pointerX;
    let pointerY = pointer.pointerY;
    // if (lastPos.zoom) {

    // }
    // account for the edge boundary/ margin
    if (elHeight > pdfHeight) {
      pointerY = pointerY - (elHeight - pdfHeight) / 2;
      console.log(`changing pointerY becuase ${elHeight} > ${pdfHeight}`);
    }

    if (elWidth > pdfWidth) {
      pointerX = pointerX - (elWidth - pdfWidth) / 2;
      console.log(`changing pointerX becuase ${elWidth} > ${pdfWidth}`);
    }

    let relativePointerPosX = (lastPos.x - pointerX) * ratio;
    let relativePointerPosY = (lastPos.y - (pointerY - topMargin)) * ratio;
    // this is so wrong.

    if (true) {
      // maybe the center it in the viewport?
      relativePointerPosX = relativePointerPosX + elWidth / 2;
      relativePointerPosY = relativePointerPosY + elHeight / 2;
    }

    const x = clamp(relativePointerPosX, getBounds().left, 0, true);
    const y = clamp(relativePointerPosY, getBounds().top, 0, true);
    if (isNaN(x) || isNaN(y)) {
      // setPointer(null);
      return;
    }
    console.log(
      'SET - relocateToPointer',
      relativePointerPosX,
      relativePointerPosY,
      x,
      y
    );
    set({
      x,
      y,
      ...immediateConfig,
    });
    setLastPos({
      x,
      y,
    });
    setPointer(null);
    setLastWidth(computedWidth);

    // else {
    //   const lw = lastWidth || computedWidth;
    //   const ratio = computedWidth / lw;

    //   clampToBounds(lastPos.x * ratio, lastPos.y * ratio);
    //   setLastWidth(computedWidth);

    //   // when do we really want to center?
    //   // do we not just want to make sure we're within bounds?
    //   // center();
    // }
  };

  const relocateToCenter = () => {
    console.log('cwlw - !', {
      computedWidth,
      lastWidth,
      lastPos,
      pointer,
    });
    // this is probably the previous value
    console.log('SET - relocateToCenter (clamptobounds)', computedWidth);

    const lw = lastWidth || computedWidth;
    const ratio = computedWidth / lw;

    clampToBounds(lastPos.x * ratio, lastPos.y * ratio, true);
    setLastWidth(computedWidth);

    // when do we really want to center?
    // do we not just want to make sure we're within bounds?
    // center();
  };

  const relocateToOrigin = () => {
    const b = getBounds();
    const { width: pdfWidth, height: pdfHeight } = pdfDimensions;
    let pinchX = pinchOrigin.x;
    let pinchY = pinchOrigin.y;
    // const { x: lastX, y: lastY } = lastPos;
    const lastX = x.get();
    const lastY = y.get();
    // const { x: pinchX, y: pinchY } = pinchOrigin;

    const ratio = computedWidth / lastWidth;
    if (elHeight > pdfHeight) {
      pinchY = pinchY - (elHeight - pdfHeight) / 2;
      console.log(`changing pointerY becuase ${elHeight} > ${pdfHeight}`);
    }

    if (elWidth > pdfWidth) {
      pinchX = pinchX - (elWidth - pdfWidth) / 2;
      console.log(`changing pointerX becuase ${elWidth} > ${pdfWidth}`);
    }

    // not sure how this would work considering it doesn't
    // account for the pointer position / transform origin
    const rightOffset = pdfWidth - elWidth - -lastX;
    const leftOffset = pdfWidth - elWidth - rightOffset;
    const topOffset = pdfHeight - elHeight - -lastY;
    const bottomOffset = pdfHeight - elHeight - topOffset;
    // const differenceX = ratio * leftOffset;
    // const differenceY = ratio * bottomOffset;
    // console.log('difference', differenceX, differenceY);
    // let newX = clamp(-differenceX + -pinchX, b.left, 0, true);
    // let newY = clamp(-differenceY + (-pinchY + topMargin), b.top, 0, true);

    const zoomOffset = lastPos.zoom > 0 ? lastPos.zoom - 1 : lastPos.zoom + 1;
    // const zoomOffset =
    //   lastPos.zoom > 1
    //     ? lastPos.zoom - 1 Math.floor(lastPos.zoom)
    //     : lastPos.zoom < 0
    //     ? lastPos.zoom * -1 // - Math.floor(lastPos.zoom * -1)
    //     : lastPos.zoom - 1;

    const xOffset = pinchX + leftOffset;
    const yOffset = pinchY - topMargin + bottomOffset;
    console.log('xoffset, ', pinchX, leftOffset, -xOffset);
    console.log('yoffset, ', pinchY, bottomOffset, -yOffset);
    console.log('zOffset', zoomOffset);
    console.log('zoom', lastPos.zoom);
    console.log('xoffset b4 clamp', lastX + -xOffset * zoomOffset);
    console.log('yoffset b4 clamp', lastY + -xOffset * zoomOffset);

    let newX = clamp(lastX + -xOffset * zoomOffset, getBounds().left, 0, true);
    let newY = clamp(lastY + -yOffset * zoomOffset, getBounds().top, 0, true);

    // let newX = clamp(lastX * ratio * (xRatio + 1), getBounds().left, 0, true);
    // let newY = clamp(lastY * ratio * (yRatio + 1), getBounds().top, 0, true);

    // let newX = clamp(-getPinchOrigin().x || 0, getBounds().left, 0, true);
    // let newY = clamp(
    //   -getPinchOrigin().y || 0 - topMargin,
    //   getBounds().top,
    //   0,
    //   true
    // );
    // if (true) {
    //   // maybe the center it in the viewport?
    //   x = x + elWidth / 2;
    //   y = y + elHeight / 2;
    // }

    console.log(
      'SET - relocate origin:',
      { lastX, lastY },
      { pinchX: -pinchX, pinchY: -pinchY - topMargin },
      ratio,
      newX,
      newY
    );
    set({
      x: newX,
      y: newY,
      ...immediateConfig,
    });
    setLastPos({
      x: newX,
      y: newY,
    });
    setPointer(null);
    setLastWidth(computedWidth);
  };

  const getPinchOrigin = useCallback(() => {
    if (pdfDimensions && pinchOrigin && pinchOrigin.x) {
      // const b = getBounds();

      // const { x: pinchX, y: pinchY } = pinchOrigin;
      let pinchX = pinchOrigin.x;
      let pinchY = pinchOrigin.y;
      const ratio = computedWidth / elWidth;
      // the transform origin element is the full viewport width (minus the menu [topMargin])
      // so we don't need to offset it
      // if (elHeight > pdfHeight) {
      //   pinchY = pinchY - (elHeight - pdfHeight) / 2;
      //   console.log(`changing pinchY becuase ${elHeight} > ${pdfHeight}`);
      // }

      // if (elWidth > pdfWidth) {
      //   pinchX = pinchX - (elWidth - pdfWidth) / 2;
      //   console.log(`changing pinchX becuase ${elWidth} > ${pdfWidth}`);
      // }
      const lastX = x.get();
      const lastY = y.get();
      let newX = -lastX + pinchX;
      let newY = -lastY + (pinchY - topMargin);

      // let x = -lastX + pinchX; //clamp(-lastX + pinchX * ratio, b.left, 0, true);
      // let y = -lastY + (pinchY - topMargin); //clamp(-lastY + pinchY * ratio, b.top, 0, true);
      // if (true) {
      //   // maybe the center it in the viewport?
      //   x = x + elWidth / 2;
      //   y = y + elHeight / 2;
      // }

      console.log('pinch origin:', -lastX, pinchX, ratio, newX, newY);
      return { x: newX, y: newY, transformOrigin: `${newX}px ${newY}px` };
    } else {
      return { transformOrigin: '0 0' };
    }
  }, [pinchOrigin.x, pinchOrigin.y]);

  // react to scale changes in the pdf, delegate to different
  // functions depending on the action
  useLayoutEffect(() => {
    console.log({ lastAction });
    if (pdfDimensions && pdfDimensions.width) {
      // non-pointer/pinch based zoom
      if (computedWidth !== lastWidth && !pointer && !lastPos?.zoom) {
        console.log('effect relocateToCenter');
        relocateToCenter();
        return;
      }
      // pinch zoom
      if (
        computedWidth !== lastWidth &&
        lastPos?.zoom &&
        lastAction === 'pinch'
      ) {
        console.log('effect relocateToOrigin');

        relocateToOrigin();
        return;
      }
      // double tap zoom
      if (
        computedWidth !== lastWidth &&
        pointer &&
        !lastPos?.zoom
        //  &&
        // lastAction === 'tap'
      ) {
        console.log('effect relocateToPointer');

        relocateToPointer();
        return;
      }
    }
  }, [
    // computedWidth,
    pdfDimensions && pdfDimensions.width,
    // pdfDimensions && pdfDimensions.height,
    // bounds,
  ]);

  // useEffect(() => {
  //   // this reacts to changes in the pdf document container width/height
  //   // and sets the new xy pos based on the pointer pos
  //   // it clamps it to the boundary and centers the view on the pointer pos
  //   // (i.e this is the double click (and pinch zoom) effect)
  //   console.log('cwlw', { computedWidth, lastWidth, pointer });
  //   if (computedWidth !== lastWidth && pdfEl) {
  //     const { width: pdfWidth, height: pdfHeight } = pdfDimensions;
  //     console.log('computed width updated', computedWidth, pdfDimensions);

  //     //    if (lastAction === 'pinch') {
  //     //   console.log('returning from pinch');
  //     //   setLastAction(null);
  //     //   return;
  //     // }

  //     if (pointer) {
  //       console.log(
  //         'pointer adjust:',
  //         lastPos,
  //         lastPos.x + -pointer.pointerX,
  //         lastPos.y + -pointer.pointerY
  //         // -lastPos.pointer.pointerX - -elWidth / 2,
  //         // -lastPos.pointer.pointerY - -elHeight / 2
  //       );

  //       // console.log('currentZoom ratio?', currentZoom);
  //       // console.log('zoom spring', zoom.get(), lastPos.zoom);
  //       const lw = lastWidth || computedWidth;
  //       // this seems to succesfully move to the pointer pos after scaling
  //       // but we probably want to then center that
  //       const ratio = computedWidth / lw;
  //       let pointerX = pointer.pointerX;
  //       let pointerY = pointer.pointerY;
  //       // account for the edge boundary/ margin
  //       if (elHeight > pdfHeight) {
  //         pointerY = pointerY - (elHeight - pdfHeight) / 2;
  //         console.log(`changing pointerY becuase ${elHeight} > ${pdfHeight}`);
  //       }

  //       if (elWidth > pdfWidth) {
  //         pointerX = pointerX - (elWidth - pdfWidth) / 2;
  //         console.log(`changing pointerX becuase ${elWidth} > ${pdfWidth}`);
  //       }

  //       let relativePointerPosX = (lastPos.x - pointerX) * ratio;
  //       let relativePointerPosY = (lastPos.y - (pointerY - topMargin)) * ratio;
  //       // this is so wrong.

  //       if (true) {
  //         // maybe the center it in the viewport?
  //         relativePointerPosX = relativePointerPosX + elWidth / 2;
  //         relativePointerPosY = relativePointerPosY + elHeight / 2;
  //       }

  //       const x = clamp(relativePointerPosX, getBounds().left, 0, true);
  //       const y = clamp(relativePointerPosY, getBounds().top, 0, true);
  //       if (isNaN(x) || isNaN(y)) {
  //         // setPointer(null);
  //         return;
  //       }
  //       console.log('SET - cw', relativePointerPosX, relativePointerPosY, x, y);
  //       set({
  //         x,
  //         y,
  //         ...immediateConfig,
  //       });
  //       setLastPos({
  //         x,
  //         y,
  //       });
  //       setPointer(null);
  //       setLastWidth(computedWidth);
  //     }
  //     // else {
  //     //   const lw = lastWidth || computedWidth;
  //     //   const ratio = computedWidth / lw;

  //     //   clampToBounds(lastPos.x * ratio, lastPos.y * ratio);
  //     //   setLastWidth(computedWidth);

  //     //   // when do we really want to center?
  //     //   // do we not just want to make sure we're within bounds?
  //     //   // center();
  //     // }
  //   }
  // }, [
  //   // computedWidth,
  //   pdfDimensions && pdfDimensions.width,
  //   pdfDimensions && pdfDimensions.height,
  //   // bounds,
  // ]);

  // when using regular zoom, zoom to last position clamped to the bounds

  const [bounds, setBounds] = useState({
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  });

  // the bounds can change even in the pdf dimensions didn't change
  useEffect(() => {
    const b = getBounds();
    if (isEqual(b, bounds)) return;

    console.log(
      'update bounds on computedWidth/pdfDimensions/elWidth change',
      b
    );
    setBounds(b);
  }, [
    computedWidth,
    pdfDimensions && pdfDimensions.width,
    pdfDimensions && pdfDimensions.height,
    elWidth,
    elHeight,
  ]);

  const getBounds = useCallback(() => {
    if (!pdfEl) return { top: 0, left: 0, right: 0, bottom: 0 };
    const { width: pdfWidth, height: pdfHeight } = pdfDimensions;
    // const difX = pdfWidth - elWidth;
    // const difY = pdfHeight - elHeight;

    let left = 0,
      right = pdfWidth - elWidth,
      bottom = pdfHeight - elHeight,
      top = 0;
    // console.log('bounds dims', { pdfWidth, pdfHeight, elWidth, elHeight });
    // handle scale > viewport
    if (pdfWidth <= elWidth) {
      const difX = elWidth - pdfWidth;
      // left = difX;
      // right = 0;
      //force centering
      left = difX / 2;
      right = difX / 2;

      // console.log('bounds pdfWidth <= elWidth');
    } else if (pdfWidth >= elWidth) {
      // console.log('bounds pdfWidth >= elWidth');

      right = 0;
      left = elWidth - pdfWidth;
    }
    if (pdfHeight <= elHeight) {
      const difY = elHeight - pdfHeight;
      // console.log('bounds pdfHeight <= elHeight', pdfHeight, elHeight);
      // bottom = 0;
      // top = difY;
      //force centering
      top = difY / 2;
      bottom = difY / 2;
    } else if (pdfHeight >= elHeight) {
      top = elHeight - pdfHeight;
      bottom = 0;
    }
    const bounds = {
      left: Math.ceil(left),
      right: Math.ceil(right),
      top: Math.ceil(top),
      bottom: Math.ceil(bottom),
    };
    console.log('bounds:', bounds);
    return bounds;
  }, [
    computedWidth,
    pdfDimensions && pdfDimensions.width,
    pdfDimensions && pdfDimensions.height,
    elWidth,
    elHeight,
  ]);

  const clampToBounds = (lastX = lastPos.x, lastY = lastPos.y, center) => {
    const b = getBounds();
    const { width: pdfWidth, height: pdfHeight } = pdfDimensions;
    let x;
    let y;
    if (center) {
      // not actually sure how to center on the last position

      x = clamp(lastX, b.left, 0, true);
      y = clamp(lastY, b.top, 0, true);
    } else {
      x = clamp(lastX, b.left, 0, true);
      y = clamp(lastY, b.top, 0, true);
    }

    set({
      x,
      y,
      ...immediateConfig,
    });
    // console.log('SET - clamped', x, y);

    setLastPos({ x, y });
  };

  const center = useCallback(() => {
    if (pdfDimensions) {
      const { width: pdfWidth, height: pdfHeight } = pdfDimensions;

      const x = elWidth / 2 - pdfWidth / 2;
      // don't center on the Y axis if pdf is higher than viewport
      const y = pdfHeight > elHeight ? 0 : elHeight / 2 - pdfHeight / 2;
      set({
        x,
        y,
      });
      // console.log('SET - center', x, y);

      setLastPos({ x, y });
    }
  }, [pdfDimensions, elWidth, elHeight]);

  // Set the drag hook and define component movement based on gesture data
  const bind = useGesture(
    {
      onPinchStart: ({ origin: [x, y] }) => {
        setDisableBounds(true);
        setPinchOrigin({ x, y });
      },
      onPinch: ({ offset: [d], movement: [m], origin: [x, y] }) => {
        if (m < 600 && m > 100) setZoom({ zoom: m / 200 });
      },
      onPinchEnd: ({ offset: [d], movement: [m], origin: [x, y] }) => {
        // somehow translate the zoom level to
        // the pdf zoom
        const {
          width: pdfWidth,
          // height: pdfHeight,
        } = pdfEl.getBoundingClientRect();

        // we should just tell it to make it the exact width of pdfEl now,
        // because that's the scaled up (correct) value
        // console.log('new zoom w:', pdfWidth);

        //  I changed the function to:
        // handleZoom(factor, newWidth)
        const nw = (pdfWidth * clamp(m, 0, 600)) / 200; // ?
        setLastAction('pinch');
        setLastWidth(computedWidth);
        setLastPos({
          ...lastPos,
          // not using this?
          zoom: m / 200,
        });
        // how to make this not animate?
        setZoom({ zoom: 1 });
        console.log('handleZoom int');
        handleZoom(null, pdfWidth);
        setDisableBounds(false);
      },

      // onMouseDown: ({ xy: [pointerX, pointerY] }) => {},
      onDrag: ({
        tap,
        down,
        last,
        xy: [pointerX, pointerY],
        offset: [ox, oy],
        movement: [mx, my],
        swipe: [swipeX],
      }) => {
        if (lastAction === 'pinch') return;
        if (tap) {
          console.log('set on tap', { pointerX, pointerY });
          setLastPos({
            // ...lastPos,
            x: Math.ceil(mx),
            y: Math.ceil(my),
          });
          setLastAction('tap');
          setPointer({ pointerX: pointerX, pointerY: pointerY });

          return;
        }
        console.log(
          'SET - drag',
          !down ? Math.ceil(mx) : mx,
          down ? Math.ceil(my) : my
        );

        set({
          x: !down ? Math.ceil(mx) : mx,
          y: !down ? Math.ceil(my) : my,
          // immediate: down,
        });

        // if (swipeX) {
        //   // this should only really trigger
        //   // - 1 = swipe left = next page
        //   // under certain conditions (not zoomed in)
        //   if (swipeX === -1 && ox === bounds.left) {
        //     swipeLeft();
        //   }
        //   if (swipeX === 1 && ox === bounds.right) {
        //     swipeRight();
        //   }
        // }
      },
      onDragStart: ({ movement: [mx, my] }) => {
        setLastAction('drag');

        set({
          x: mx,
          y: my,
          ...defaultConfig,
        });
      },
      onDragEnd: ({ movement: [mx, my], xy: [x, y] }) => {
        setLastPos({
          x: Math.ceil(mx),
          y: Math.ceil(my),
        });
        setPointer({ pointerX: x, pointerY: y });

        setLastWidth(computedWidth);
      },
      onWheelStart: ({ movement: [mx, my] }) =>
        set({
          x: mx,
          y: my,
          ...defaultConfig,
        }),
      onWheel: ({
        wheeling,
        direction,
        // offset: [ox, oy],
        movement: [mx, my],
      }) => {
        set({
          x: !wheeling ? Math.ceil(mx) : mx,
          y: !wheeling ? Math.ceil(my) : my,
          // immediate: down,
        });
      },
      onWheelEnd: ({ offset: [ox, oy], xy: [pointerX, pointerY] }) => {
        setLastPos({
          x: Math.ceil(ox),
          y: Math.ceil(oy),
        });
        // setLastWidth(computedWidth);
      },
    },
    {
      pinch: { initial: () => [zoom.get() * 200], bounds: bounds },
      drag: {
        filterTaps: true,
        bounds: bounds, //disableBounds ? undefined :
        rubberband: true,
        initial: () => [
          !isNaN(x.get()) ? x.get() : 0,
          !isNaN(y.get()) ? y.get() : 0,
        ],
      },
      wheel: {
        bounds: bounds, //disableBounds ? undefined :
        rubberband: false,
        initial: () => [
          !isNaN(x.get()) ? x.get() : 0,
          !isNaN(y.get()) ? y.get() : 0,
        ],
      },
    }
  );

  return (
    <div
      id={'drag-wrapper'}
      onDoubleClick={onDoubleClick}
      ref={ref}
      style={{
        position: 'absolute',
        top: topMargin,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: 'hidden',
        cursor: 'grab',
        touchAction: 'none',
        backgroundColor: '#fafafa',
      }}
    >
      {/* <div
        style={{
          position: 'absolute',
          fontFamily: 'monospace',
          fontWeight: 'bold',
          zIndex: 1,
          left: '50%',
          background: 'whitesmoke',
          padding: 5,
        }}
      >
        <p>PO: {`${pinchOrigin.x}, ${pinchOrigin.y}`}</p>
        <p>TO: {getPinchOrigin().transformOrigin}</p>
        <p>LP: {`${lastPos.x}, ${lastPos.y}`}</p>
      </div>
      <div
        style={{
          position: 'absolute',
          left: getPinchOrigin().x,
          top: getPinchOrigin().y,
          color: 'pink',
          zIndex: 2,
          width: 5,
          height: 5,
          backgroundColor: 'pink',
          borderRadius: '100%',
          border: '1px solid black',
        }}
      ></div> */}
      <animated.div
        {...bind()}
        style={{
          x,
          y,
          scale3d: !disableBounds ? [1, 1, 1] : [zoom, zoom, 1],
          // transformOrigin: '0 0',
          transformOrigin: getPinchOrigin().transformOrigin,

          // pointer
          //   ? // `${pdfDimensions.width / 2}px ${pdfDimensions.height / 2}px`
          //     getPinchOrigin()
          //   : // `${-lastPos.x - -pointer.pointerX + elWidth / 2}px ${-lastPos.y -
          //     //     (-pointer.pointerY + topMargin) +
          //     //     elHeight / 2}px`
          //     // `${lastPos.x -
          //     //   pointer.pointerX * zoom.get() +
          //     //   elWidth / 2}px ${lastPos.y -
          //     //   (pointer.pointerY - topMargin) * zoom.get() +
          //     //   elHeight / 2}px`
          //     '0 0', // `${elWidth / 2}px ${elHeight / 2}px`,
        }}
      >
        {children}
      </animated.div>
    </div>
  );
};

export default GestureHandler;
